import {
	JIRASERVICEMANAGEMENT,
	type Solutions,
} from '@atlassian/jira-common-constants/src/solutions-types.tsx';
import getApplicationSubProduct from '../get-application-sub-product/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): Solutions[] | undefined =>
	getApplicationSubProduct() === 'serviceDesk' ? [JIRASERVICEMANAGEMENT] : undefined;
